<template>
  <div :class="`animation animation-${loaded ? 'loaded' : 'wait'} animation-hulk animation-hulk-${theme}`">
    <HulkSvg/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import HulkSvg from '@/components/Animation/HulkSvg';

export default {
  components: {
    HulkSvg,
  },

  computed: mapGetters({
    loaded: 'loaded',
    theme: 'theme',
  }),

  watch: {
    theme() {
      clearTimeout(this.disableTimeout);
      if (this.inViewport) {
        this.disableAnimation = false;
        this.checkCurrentTheme();
      } else {
        this.disableTimeout = setTimeout(() => {
          this.disableAnimation = true;
          this.checkCurrentTheme();
        }, 3000);
      }
    },
  },

  props: ['inViewport'],

  data() {
    return {
      timeoutsAnimation: {},
      disableAnimation: false,
      disableTimeout: null,
      normalHands: null,
      normalHead: null,
      greenBody: null,
      greenHead: null,
      glasses: null,
      green: null,
      timing: 900,
      white: [],
    };
  },

  mounted() {
    const hulk = window.SVG.select('#hulk-wrap');
    hulk.opacity(0);

    if (this.theme === 'dark') {
      this.disableAnimation = true;
      this.timing = 1;
    }
    setTimeout(() => {
      setTimeout(() => {
        this.disableAnimation = false;
        this.timing = 900;
        hulk.animate(200).opacity(1);
      }, 400);
      this.initSVG();
    }, 300);
  },

  methods: {
    initSVG() {
      const SVG = window.SVG;

      this.white = [
        {
          root: SVG.select('#hulk-jacket-right-part'),
          transform: {
            scale: 1.3,
            rotate: 40,
            translate: {
              x: 30,
              y: 120,
            },
          },
        },
        {
          root: SVG.select('#hulk-jacket-left-part'),
          transform: {
            scale: 1.3,
            rotate: 40,
            translate: {
              x: -660,
              y: 120,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-hand-broke'),
          transform: {
            scale: 1.3,
            rotate: 2,
            translate: {
              x: -821,
              y: 170,
            },
          },
        },
        {
          root: SVG.select('#hulk-right-hand-broke'),
          transform: {
            scale: 1.3,
            rotate: 20,
            translate: {
              x: -28,
              y: -360,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-top-foot'),
          transform: {
            scale: 1.38,
            rotate: 40,
            translate: {
              x: -728,
              y: -260,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-foot-bottom-broke'),
          transform: {
            scale: 1.3,
            rotate: 2,
            translate: {
              x: -710,
              y: -292,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-foot-bottom-broke-2'),
          transform: {
            scale: 1.3,
            rotate: 2,
            translate: {
              x: -710,
              y: 62,
            },
          },
        },
        {
          root: SVG.select('#hulk-right-top-foot-broke-1'),
          transform: {
            scale: 1.38,
          },
        },
        {
          root: SVG.select('#hulk-right-bottom-foot-broke'),
          transform: {
            scale: 1.3,
            rotate: 2,
            translate: {
              x: 410,
              y: 62,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-shoes-1'),
        },
        {
          root: SVG.select('#hulk-right-shoes'),
        },
        {
          root: SVG.select('#hulk-suitcase'),
          transform: {
            translate: {
              x: 28,
              y: 360,
            },
          },
        },
        {
          root: SVG.select('#hulk-left-white-broke'),
          transform: {
            scale: 1.3,
            rotate: 2,
            translate: {
              x: -21,
              y: 70,
            },
          },
        },
        {
          root: SVG.select('#hulk-right-white-broke'),
          transform: {
            scale: 1.3,
            rotate: 20,
            translate: {
              x: -730,
              y: 20,
            },
          },
        },
        {
          root: SVG.select('#hulk-shirt'),
        },
        {
          root: SVG.select('#hulk-white-broke'),
        },
        {
          root: SVG.select('#hulk-tie'),
        },
        {
          root: SVG.select('#hulk-right-hand-arm'),
        },
        {
          root: SVG.select('#hulk-human-body'),
        },
      ];

      this.normalHands = SVG.select('#hulk-human-hands');
      this.normalHead = SVG.select('#hulk-face');

      this.green = SVG.select('#hulk-green');
      this.greenBody = SVG.select('#hulk-green-body');
      this.greenHead = SVG.select('#hulk-green-head');
      this.glasses = SVG.select('#hulk-glasses-broke');

      this.green.transform({
        scaleX: 0.8,
      }).opacity(0);

      this.greenBody.opacity(0).scale(1).x(1);
      this.glasses.opacity(0).y(0);
      this.greenHead.rotate(0).scale(1).y(0).opacity(0);

      this.checkCurrentTheme();
    },

    checkCurrentTheme() {
      if (this.theme === 'dark') {
        this.darkStatus();
      } else {
        this.whiteStatus();
      }
    },

    whiteStatus() {
      this.clearTimeouts();
      this.disableAnimation = false;
      this.timing = 900;
      this.greenHead.animate(600).rotate(0).scale(1).y(0);
      this.glasses.animate(300).opacity(0).y(0);
      this.timeoutsAnimation.whiteMain = setTimeout(() => {
        this.greenBody.animate(300).opacity(1);
      }, 200);

      for (let m = 0; m < this.white.length; m += 1) {
        const el = this.white[m];
        this.clearTransform(el);
      }

      this.hideDarkElements();

      this.timeoutsAnimation.whiteHands = setTimeout(() => {
        const normalElsTime = 300;
        this.normalHands.animate(normalElsTime).opacity(1);
        this.normalHead.animate(normalElsTime).opacity(1);
      }, 1000);

      this.timeoutsAnimation.whiteHead = setTimeout(() => {
        this.greenHead.animate(300).opacity(0);
      }, 1800);
    },

    darkStatus() {
      this.clearTimeouts();
      const normalElsTime = this.disableAnimation ? 0 : 300;
      this.normalHands.animate(normalElsTime).opacity(0);
      this.normalHead.animate(normalElsTime).opacity(0);
      this.greenHead.opacity(1);

      this.timeoutsAnimation.darkMain = setTimeout(() => {
        this.greenHead.opacity(1);
        for (let m = 0; m < this.white.length; m += 1) {
          const el = this.white[m];
          this.setTransform(el);
        }
        this.timeoutsAnimation.darkBody = setTimeout(() => {
          this.greenBody.animate(this.disableAnimation ? 0 : 300).opacity(0);
        }, this.disableAnimation ? 0 : 1000);
        this.timeoutsAnimation.darkHead = setTimeout(() => {
          this.showDarkElements();

          this.greenHead.animate(this.disableAnimation ? 10 : 500).rotate(9).scale(1.1);
          this.greenHead.animate(this.disableAnimation ? 10 : 100).y(20).cy(20);
          // .y(25);
          // .cy(50);
          this.timeoutsAnimation.darkGlasses = setTimeout(() => {
            this.glasses.y(10);
            this.glasses.animate(this.disableAnimation ? 10 : 1000).opacity(1);
          }, this.disableAnimation ? 10 : 600);
        }, this.disableAnimation ? 10 : 900);
      }, this.disableAnimation ? 10 : 300);
    },

    setTransform(el) {
      const sc = el.transform && el.transform.scale ? el.transform.scale : 1;
      const stan = { x: 0, y: 0 };
      const trans = el.transform && el.transform.translate ? el.transform.translate : stan;
      el.root.animate(this.timing).transform({
        scaleX: sc,
        scaleY: sc > 1.2 ? sc - 0.2 : sc,
      });
      this.timeoutsAnimation.transform = setTimeout(() => {
        el.root.animate(this.timing).move(trans.x, trans.y).opacity(0);
      }, this.disableAnimation ? 0 : 400);
    },

    clearTransform(el) {
      el.root.animate(this.timing).transform({
        scaleX: 1,
        scaleY: 1,
      })
      .move(0, 0)
      .opacity(1);
    },

    hideDarkElements() {
      this.green.animate(this.timing).transform({
        scaleX: 0.8,
      }).opacity(0);
    },

    showDarkElements() {
      this.green.animate(this.timing).transform({
        scaleX: 1,
      }).opacity(1);
    },

    clearTimeouts() {
      clearTimeout(this.timeoutsAnimation.darkMain);
      clearTimeout(this.timeoutsAnimation.darkBody);
      clearTimeout(this.timeoutsAnimation.darkHead);
      clearTimeout(this.timeoutsAnimation.darkGlasses);
      clearTimeout(this.timeoutsAnimation.transform);
      clearTimeout(this.timeoutsAnimation.whiteMain);
      clearTimeout(this.timeoutsAnimation.whiteHands);
      clearTimeout(this.timeoutsAnimation.whiteHead);
    },
  },
};
</script>


<style>
  @keyframes righthand{
    0%, 80%{
      opacity: 1;
    }
    100%{
      opacity: 0;
    }
  }

  .animation-hulk{
    transition: all .3s ease-in-out;
    position: absolute;
    max-width: 280px;
    height: auto;
    width: 27vw;
    opacity: 0;
    left: -2vw;
    top: 0;

    @media (max-width: $mediaSmallScreen) {
      left: -5vw;
    }

   &.animation-loaded{
      .page-theme.in-viewport &{
        opacity: 1;
      }
    }

    @media (max-width: $mediaMob) {
      width: 22vw;
      top: -15vw;
      left: -5vw;
    }

    @media (max-width: $mediaMini) {
      top: -30vw;
    }

    svg{
      max-width: 100%;
      width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Animation/Hulk.vue